// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"162":"6fa633fc","616":"d987cfe2","715":"6677de34","987":"5727b358"}[chunkId] + ".chunk.css";
};